import { VideoResult } from "common/video/dto/VideoResult";

export const videoFormDefaultValuesGet = (video?: VideoResult) => {
  if (video) {
    return {
      datum: video.datum,
      title: video.title,
      fileName: video.fileName,
    };
  } else {
    return {
      datum: new Date(),
      title: "",
      fileName: "",
    };
  }
};
